import { render } from "./MyButton.vue?vue&type=template&id=66dc1501"
const script = {}

import exportComponent from "/home/teamcity-agent/agent3/work/1e41b97f3be6577f/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
